exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marketplace-logos[data-v-8b93d056]{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.marketplace-logos span+span[data-v-8b93d056]{margin-left:5px}.marketplace-logo[data-v-8b93d056]{display:inline-block;max-width:65px;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b93d056","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Admin/Users.vue
// module id = j8db
// module chunks = 1